/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Response for LuBillEtransferData
 * @export
 * @interface LuBillEtransferDataResponse
 */
export interface LuBillEtransferDataResponse {
    /**
     * 
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    luBillEtransferDataUuid?: string;
    /**
     * PID simulation timestamp
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    pidSimulationTimestamp?: string;
    /**
     * CNS authorization number
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    cnsAuthorizationNumber?: string;
    /**
     * CNS Document UUID
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    cnsAuthorizationUuid?: string;
    /**
     * CNS part amount
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    cnsPartAmount?: string;
    /**
     * Paid by patient amount
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    paidByPatientAmount?: string;
    /**
     * PID validation timestamp
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    pidValidationTimestamp?: string;
    /**
     * PID contestation timestamp
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    pidContestationTimestamp?: string;
    /**
     * Reason of contestation
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    contestationReason?: string;
    /**
     * Id of the anomaly to contest
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    contestationId?: string;
    /**
     * Type of the contestation
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    contestationType?: string;
    /**
     * RA validation timestamp
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    raValidationTimestamp?: string;
    /**
     * RA cancellation timestamp
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    raCancellationTimestamp?: string;
    /**
     * Auto-generated UUID if cancellation
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    cancellationUuid?: string;
    /**
     * Reason for cancellation
     * @type {string}
     * @memberof LuBillEtransferDataResponse
     */
    cancellationReason?: string;
    /**
     * Type of cancellation
     * @type {number}
     * @memberof LuBillEtransferDataResponse
     */
    cancellationType?: number;
}

/**
 * Check if a given object implements the LuBillEtransferDataResponse interface.
 */
export function instanceOfLuBillEtransferDataResponse(value: object): value is LuBillEtransferDataResponse {
    return true;
}

export function LuBillEtransferDataResponseFromJSON(json: any): LuBillEtransferDataResponse {
    return LuBillEtransferDataResponseFromJSONTyped(json, false);
}

export function LuBillEtransferDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): LuBillEtransferDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'luBillEtransferDataUuid': json['luBillEtransferDataUuid'] == null ? undefined : json['luBillEtransferDataUuid'],
        'pidSimulationTimestamp': json['pidSimulationTimestamp'] == null ? undefined : json['pidSimulationTimestamp'],
        'cnsAuthorizationNumber': json['cnsAuthorizationNumber'] == null ? undefined : json['cnsAuthorizationNumber'],
        'cnsAuthorizationUuid': json['cnsAuthorizationUuid'] == null ? undefined : json['cnsAuthorizationUuid'],
        'cnsPartAmount': json['cnsPartAmount'] == null ? undefined : json['cnsPartAmount'],
        'paidByPatientAmount': json['paidByPatientAmount'] == null ? undefined : json['paidByPatientAmount'],
        'pidValidationTimestamp': json['pidValidationTimestamp'] == null ? undefined : json['pidValidationTimestamp'],
        'pidContestationTimestamp': json['pidContestationTimestamp'] == null ? undefined : json['pidContestationTimestamp'],
        'contestationReason': json['contestationReason'] == null ? undefined : json['contestationReason'],
        'contestationId': json['contestationId'] == null ? undefined : json['contestationId'],
        'contestationType': json['contestationType'] == null ? undefined : json['contestationType'],
        'raValidationTimestamp': json['raValidationTimestamp'] == null ? undefined : json['raValidationTimestamp'],
        'raCancellationTimestamp': json['raCancellationTimestamp'] == null ? undefined : json['raCancellationTimestamp'],
        'cancellationUuid': json['cancellationUuid'] == null ? undefined : json['cancellationUuid'],
        'cancellationReason': json['cancellationReason'] == null ? undefined : json['cancellationReason'],
        'cancellationType': json['cancellationType'] == null ? undefined : json['cancellationType'],
    };
}

export function LuBillEtransferDataResponseToJSON(json: any): LuBillEtransferDataResponse {
    return LuBillEtransferDataResponseToJSONTyped(json, false);
}

export function LuBillEtransferDataResponseToJSONTyped(value?: LuBillEtransferDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'luBillEtransferDataUuid': value['luBillEtransferDataUuid'],
        'pidSimulationTimestamp': value['pidSimulationTimestamp'],
        'cnsAuthorizationNumber': value['cnsAuthorizationNumber'],
        'cnsAuthorizationUuid': value['cnsAuthorizationUuid'],
        'cnsPartAmount': value['cnsPartAmount'],
        'paidByPatientAmount': value['paidByPatientAmount'],
        'pidValidationTimestamp': value['pidValidationTimestamp'],
        'pidContestationTimestamp': value['pidContestationTimestamp'],
        'contestationReason': value['contestationReason'],
        'contestationId': value['contestationId'],
        'contestationType': value['contestationType'],
        'raValidationTimestamp': value['raValidationTimestamp'],
        'raCancellationTimestamp': value['raCancellationTimestamp'],
        'cancellationUuid': value['cancellationUuid'],
        'cancellationReason': value['cancellationReason'],
        'cancellationType': value['cancellationType'],
    };
}

